import { ICart, ILineItem } from '../../../../types';
import toDataLayerProduct from './product';
import { formatCurrencyToTwoDecimals } from '../../../utils';

export default function toDataLayer(
  cart: ICart,
  lineItem: ILineItem,
  prefix: string = 'cart_product_',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Record<string, any> {
  // this is using the lineItem as both the variant and the product, since it looks like
  // the data in _elco_page_data is going to be flattened for line items
  const productData = toDataLayerProduct(lineItem, lineItem, prefix);

  // Merge product data with line item-specific fields
  const lineItemData = {
    ...productData,
    [`${prefix}quantity`]: [lineItem.quantity],
    [`${prefix}price`]: [
      formatCurrencyToTwoDecimals(lineItem.final_unit_amount || 0),
    ],
    [`${prefix}was_price`]: [
      formatCurrencyToTwoDecimals(lineItem.original_unit_amount || 0),
    ],
    [`${prefix}discount_amount`]: [
      formatCurrencyToTwoDecimals((lineItem.discount_total_amount || 0) * -1),
    ],
    [`${prefix}cart_id`]: [cart?.uuid],
    // TODO: Implement auto-replenishment fields as necessary
    [`${prefix}is_replenishment_item`]: ['TBD'],
    [`${prefix}replenishment_frequency`]: ['TBD'],
    [`${prefix}collection_id`]: ['TBD'],
    [`${prefix}collection_name`]: ['TBD'],
  };

  return lineItemData;
}
